module.exports = __webpack_public_path__ + "static/media/kwikset.f4638e55.png";